import { useEffect, useRef } from "react";

/** Deep purple/black base with slow-moving radial gradient spotlight for Neon theme */
export default function NeonBackground() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let animationId: number;
    let t = 0;

    const animate = () => {
      t += 0.002;
      if (ref.current) {
        const x = 50 + Math.sin(t) * 15;
        const y = 50 + Math.cos(t * 0.7) * 15;
        ref.current.style.background = `
          radial-gradient(
            ellipse 80% 60% at ${x}% ${y}%,
            rgba(168, 85, 247, 0.08) 0%,
            rgba(99, 102, 241, 0.04) 30%,
            transparent 70%
          ),
          radial-gradient(
            ellipse 120% 80% at ${100 - x}% ${100 - y}%,
            rgba(236, 72, 153, 0.05) 0%,
            transparent 50%
          ),
          linear-gradient(180deg, #0a0612 0%, #050308 100%)
        `;
      }
      animationId = requestAnimationFrame(animate);
    };

    animate();
    return () => cancelAnimationFrame(animationId);
  }, []);

  return (
    <div
      aria-hidden
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 0,
        pointerEvents: "none",
      }}
    >
      <div
        ref={ref}
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, #0a0612 0%, #050308 100%)",
        }}
      />
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(ellipse 100% 80% at 50% 50%, rgba(88, 28, 135, 0.15) 0%, transparent 55%)",
          animation: "neon-bg-breathe 18s ease-in-out infinite",
        }}
      />
    </div>
  );
}
